import React from 'react';

const AutoConfirm = (extraStyles?: React.CSSProperties) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={extraStyles}>
            <path d="M8 12L11 15L16 10" fill="black" fillOpacity="0.3"/>
            <path d="M8 12L11 15L16 10" fill="#EDF2F7"/>
            <path d="M4 5C4 4.45 4.45 4 5 4H19C19.55 4 20 4.45 20 5V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V5Z" fill="black" fillOpacity="0.3"/>
            <path d="M4 5C4 4.45 4.45 4 5 4H19C19.55 4 20 4.45 20 5V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V5Z" fill="#EDF2F7"/>
            <path d="M8 12L11 15L16 10M4 5C4 4.45 4.45 4 5 4H19C19.55 4 20 4.45 20 5V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V5Z" stroke="#CBD5E0" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 10L11 15L8 12" stroke="black" strokeLinecap="round"/>
        </svg>
    );
};

export default AutoConfirm;

